import { render, staticRenderFns } from "./CancellationsChart.vue?vue&type=template&id=50277bd4&"
import script from "./CancellationsChart.vue?vue&type=script&lang=js&"
export * from "./CancellationsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports